require('./loansMortgagesView.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const { withRouter } = require("react-router-dom");
const { connect } = require('react-redux');
const Immutable = require('immutable');
const PureRenderMixin = require('react-addons-pure-render-mixin');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { scrollToTop } = require('commonsUtilities/scrollUtils');
// @commons
const { OKCover } = require('commonsComponents/OKCover');
const OKHeaderLanding = require('components/commons/OKHeaderLanding/OKHeaderLanding');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
// @components
const GlobalPositionCredits = require('components/globalPosition/globalPositionCredits/globalPositionCredits');
const GlobalPositionLoans = require('components/globalPosition/globalPositionLoans/globalPositionLoans');
const GlobalPositionMortgages = require('components/globalPosition/globalPositionMortgages/globalPositionMortgages');
const { LoadingSection } = require('commonsComponents/loadingSection');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const LoansCreditsMortgagesProductBanners = require('../../components/loansAndMortgages/loansCreditsMortgagesProductBanners/loansCreditsMortgagesProductBanners');
const LoansAndMortagesLegalFooter = require('../../components/loansAndMortgages/loansAndMortagesLegalFooter/loansAndMortagesLegalFooter');
const { CallMeBack } = require('components/callMeBack/callMeBack');
const PayrollLoanRecordStatus = require('../../components/contracts/contractPayrollLoan/payrollLoanRecordStatus/payrollLoanRecordStatus');
const { CollectiveTag } = require('components/commons/collectiveTag/collectiveTag');
const MortgagesCollectiveTagTooltip = require('components/mortgagesCollectiveTagTooltip/mortgagesCollectiveTagTooltip');
const LoansError = require('components/loansAndMortgages/loans/loansError/loansError');
// @actions
const { requestPublicInformation } = require('actions/myGlobalPosition');
const { fetchPregantedCredits } = require('actions/credits/pregrantedCredits');
const { requestStatus } = require('actions/mortgagesStatus');
const { getSegmentedLoanProducts } = require('../../actions/segmentedLoanProducts');
const { cancelLoanRecord } = require('../../actions/loanRecordStatus');
const { retrieveAresDossier, cancelDossier } = require('../../actions/aresDossier');
const { getMortgageAssociatedInsurances } = require('../../actions/mortgageAssociatedInsurances');
const commercialAdsAction = require('actions/commercialInterstitialsAds');
const collectiveActions = require('actions/collectives');
const PayrollLoanRequestActions = require('actions/payrollLoanRequest');
const contractEasyLoanTypeC = require('actions/contractEasyLoanTypeC');
const mortgageRequestDataAction = require('actions/mortgageRequest/mortgageRequestMortgageData');
const mortgageRequestTaxesInformationActions = require('actions/mortgageRequest/mortgageRequestTaxesInformation');
const actionsAccount = require('actions/accounts');
//@helpers
const { mapAresDossierInfoToLoanRecord } = require('../../loansUtilities/loansHelper');
// @constants
const LOANS_MORTGAGES_SECTIONS = { MORTGAGES_IN_PROGRESS: 'mortgagesInProgress' };
const { PERSONAL_LOAN_WAFFER, NOT_ALLOWED_LOANS_CONTRACTING_ARES_COUNTRIES } = require('constants/flagBasedFeatures');
const {
    multichannelAlias: { PAYROLL_LOAN_ALIAS, MORTGAGE_GENERIC_ALIAS }
} = require('../../loansConstants/index');
const { MULTICHANNEL_UI_COMPONENT, MORTGAGE_TAXES_GROUP_CODE } = require('constants/index');
const mortgageRequestStates = require('constants/mortgageRequestStates');
const WebappRender = require('components/conditionalRender/webappRender');
const { getIdsFromPath } = require('utilities/commercialAdsHelper');
const { MORTGAGE_PRODUCT_NUMBER } = require('constants/mortgageRequestType');

const INVALID_MORTGAGES_STATUS = [
    mortgageRequestStates.SIMULACION,
    mortgageRequestStates.PRE_APROBACION,
    mortgageRequestStates.PRE_APROBADO,
    mortgageRequestStates.TASA_ESF_KO,
    mortgageRequestStates.ANULADO,
    mortgageRequestStates.FIRMADO,
    mortgageRequestStates.UNKNOWN,
    mortgageRequestStates.SIN_EXPEDIENTE
];
const { GRAPHIC_TUTOR_TYPE_6 } = require('constants/index');
const GLOBAL_POSITION_BOXES = require('constants/globalPositionBoxes');

class LoansMortgagesView extends React.Component {
    constructor(props) {
        super(props);
        this.state = { blockedAccountError: false };
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.showBlockedAccountError = this.showBlockedAccountError.bind(this);
        this.hideBlockedAccountError = this.hideBlockedAccountError.bind(this);
    }

    componentDidMount() {
        const { validateBlockedAccount, requestMortgagesStatus, getSegmentedLoanProducts, getCollectiveInfo, getMortgageAssociatedInsurances, retrieveAresDossier } = this.props;

        requestMortgagesStatus();
        getSegmentedLoanProducts();
        retrieveAresDossier();
        validateBlockedAccount();

        const loansAndMortgagesValues = this.getLoansAndMortgagesValues();

        getCollectiveInfo([
            { alias: PAYROLL_LOAN_ALIAS },
            { alias: MORTGAGE_GENERIC_ALIAS },
            ...loansAndMortgagesValues
        ], MULTICHANNEL_UI_COMPONENT);

        getMortgageAssociatedInsurances();

        //This is in order to call the service which has the ads, it's neccesary to show the products in retail loan wafer
        if (__CONTACT_CENTER__) {
            const { path } = this.props.match;
            let ids = getIdsFromPath(path);
            this.props.requestAds(ids, 'banner-b');
            this.props.requestAds(ids, 'cross-selling');
        }

        scrollToTop();
    }

    componentDidUpdate() {
        const { immLoans, immMortgageData, immTaxesInformation, taxesInformationRequest, immProfile, requestMortgageData } = this.props;
        const status = immLoans.get('mortgagesStatus');
        const isMortgagePreapproved = !!status && INVALID_MORTGAGES_STATUS.indexOf(status) === -1;

        if (!immLoans.get('isFetchingMortgagesStatus') && isMortgagePreapproved && !immMortgageData.get('isFetching') && !immMortgageData.get('hasBeenFetched')) {
            requestMortgageData();
        }

        if (!immLoans.get('isFetchingMortgagesStatus') && isMortgagePreapproved && !immMortgageData.get('isFetching') && immMortgageData.get('hasBeenFetched')) {
            const productType = immMortgageData.getIn(['data', 'tipoProducto']);
            const term = immMortgageData.getIn(['data', 'plazo']);
            const productNumber = MORTGAGE_PRODUCT_NUMBER[productType];
            const taxesHasBeenFetched = immTaxesInformation.get('taxesHasBeenFetched');
            const taxesIsFetching = immTaxesInformation.get('isFetching');

            if (!taxesHasBeenFetched && !taxesIsFetching && !!productType && term !== 0) {
                const collectiveType = immProfile.get('collectiveType');
                const code3 = collectiveType.get('code3');
                const code4 = collectiveType.get('code4');
                const mortgageInfo = {
                    type: productNumber,
                    duration: term,
                    code3,
                    code4,
                    groupCode: MORTGAGE_TAXES_GROUP_CODE
                };
                taxesInformationRequest(mortgageInfo);
            }
        }
    }

    showBlockedAccountError() {
        this.setState({ blockedAccountError: true });
        scrollToTop();
    }

    hideBlockedAccountError() {
        this.setState({ blockedAccountError: false });
        scrollToTop();
    }

    getLoansAndMortgagesValues() {
        const { immLoans } = this.props;
        const loansInformation = immLoans.get('loansByOrder');
        const mortgagesInformation = immLoans.get('mortgagesByOrder');
        const loansById = immLoans.get('byId');

        const loansAndMortgages = loansInformation.concat(mortgagesInformation);
        const loansAndMortgagesValues = loansAndMortgages.map(id => {
            const loanData = loansById.find(loan => loan.get('loanId') === id);
            return {
                type: loanData.get('product'),
                subType: loanData.get('productSubType'),
                standard: loanData.get('productStandard')
            }
        });
        return loansAndMortgagesValues.toArray();
    }

    buildCreditsContent() {
        const { immCredits, landingBoxes } = this.props;
        const expanded = landingBoxes.includes(GLOBAL_POSITION_BOXES.CREDIT_LANDING);

        if (!immCredits.get('byOrder').isEmpty()) {
            return (
                <div className="col-xs-12-cc-6 loans-mortgages-view__section" id="loans-mortgages-credits">
                    <GlobalPositionCredits
                        id={GLOBAL_POSITION_BOXES.CREDIT_LANDING}
                        expanded={expanded}
                        immCredits={immCredits}
                    />
                </div>
            );
        }
    }

    buildLoansContent() {
        const { immLoans, landingBoxes, hiringProductBanners } = this.props;
        const expanded = landingBoxes.includes(GLOBAL_POSITION_BOXES.LOANS_LANDING);
        const mortgagesIsEmpty = immLoans.get('loansByOrder').isEmpty();
        const isAccountBlockedValidationFetching = hiringProductBanners.get('isAccountBlockedValidationFetching');
        const isAccountBlockedValidationError = hiringProductBanners.get('isAccountBlockedValidationError');
        if (!mortgagesIsEmpty) {
            return (
                <div className="col-xs-12-cc-6 loans-mortgages-view__section" id="loans-mortgages-loans">
                     <GlobalPositionLoans
                        id={GLOBAL_POSITION_BOXES.LOANS_LANDING}
                        immLoans={immLoans}
                        expanded={expanded}
                        isOnPG={false}
                    />
                </div>
            );
        }
    }

    buildMortgagesContent(isMortgagePreapproved) {
        const { immLoans, landingBoxes, immMortgageAssociatedInsurances } = this.props;
        const expanded = landingBoxes.includes(GLOBAL_POSITION_BOXES.MORTGAGE_LANDING);
        const mortgagesIsEmpty = immLoans.get('mortgagesByOrder').isEmpty();
        let mortgagesContent, mortgagesInProgressContent;

        if (!mortgagesIsEmpty) {
            mortgagesContent = (
                <div className="loans-mortgages-view__section" id="loans-mortgages-mortgages">
                    <GlobalPositionMortgages
                        id={GLOBAL_POSITION_BOXES.MORTGAGE_LANDING}
                        expanded={expanded}
                        immLoans={immLoans}
                        immMortgageAssociatedInsurances={immMortgageAssociatedInsurances}
                        isOnPG={false}
                    />
                </div>
            );
        }

        if (immLoans.get('isFetchingMortgagesStatus')) {
            mortgagesInProgressContent = (
                <div className="loans-mortgages-view__empty-section">
                    <LoadingSection />
                </div>
            );
        } else {
            if (isMortgagePreapproved) {
                mortgagesInProgressContent = this.buildMortgagesInProgressEmptyState(mortgagesIsEmpty);
            }
        }

        return (
            <div className="col-xs-12-cc-6">
                {mortgagesContent}
                {mortgagesInProgressContent}
            </div>
        )
    }

    buildMortgagesInProgressEmptyState(mortgagesIsEmpty) {
        const { match: { path }, immTaxesInformation, immMortgageData, hiringProductBanners } = this.props;
        const iconClassName = `loans-mortgages-view__empty-section--icon icon`;
        let tooltipContent;

        const isAccountBlockedValidationFetching = hiringProductBanners.get('isAccountBlockedValidationFetching');
        const isAccountBlockedValidationError = hiringProductBanners.get('isAccountBlockedValidationError');
        if (immTaxesInformation.get('taxesHasBeenFetched')) {
            const immTaxes = immTaxesInformation.get('taxes');
            const mortgageType = immMortgageData.getIn(['data', 'tipoProducto']);
            const monthlyFee = immMortgageData.getIn(['data', 'cuotaMensual']);
            const tin = !!immTaxes.get('tin') ? immTaxes.getIn(['tin', 'fixed']) : '';
            const taxes = {
                tin,
                tae: immTaxes.get('tae'),
                euribor: immTaxes.get('euribor')
            };

            tooltipContent = (
                <MortgagesCollectiveTagTooltip
                    taxes={taxes}
                    mortgageType={mortgageType}
                    monthlyFee={monthlyFee}
                />
            );
        }

        const titleText = mortgagesIsEmpty
            ? "loansMortgagesLanding-mortgagesEmptyTitle"
            : "loansMortgagesLanding-mortgagesNotEmptyTitle";

        const headerTitle = (
            <React.Fragment>
                <FormattedText value={titleText} />
            </React.Fragment>
        );

        const context = 'loansMortgagesLanding-';
        const customWaferTexts = {
            waferPrimaryText: formatText(`${context}loansMortgagesLanding_wafferMortgageInProgressTitle`),
            waferButtonContent: formatText(`${context}loansMortgagesLanding_wafferMortgageInProgressButtonText`),
            waferUri: formatText(`${context}loansMortgagesLanding_wafferMortgageInProgressUrl`),
        };

        return (
            <div className="loans-mortgages-view__empty-section" id="loans-mortgages-mortgages-in-progress">
                <i className={iconClassName} />
                <OKBoxTitle value={headerTitle} inline />
                <div className="loans-mortgages-view__empty-section__collective-tag">
                    <CollectiveTag
                        extraClass={"loans-mortgages-view__mortgage-collective-tag"}
                        productAlias={MORTGAGE_GENERIC_ALIAS}
                        tooltipContent={tooltipContent}
                    />
                </div>
                 <CommercialAds
                    path={path}
                    type="wafer"
                    bgTransparent
                    section={LOANS_MORTGAGES_SECTIONS.MORTGAGES_IN_PROGRESS}
                    customWaferTexts={customWaferTexts}
                    hasAccountBlocked={isAccountBlockedValidationError}
                    isAccountBlockedValidationFetching={isAccountBlockedValidationFetching}
                    showBlockedAccountError={this.showBlockedAccountError}
                />
            </div>
        );
    }

    render() {
        const {
            match,
            immCollectives,
            immCredits,
            immLoans,
            immProfile,
            immPayrollLoanRecordStatus,
            cancelLoanRecord,
            immRetailLoan,
            immCommercialAds,
            immContractEasyLoan,
            immFlagBasedFeatures,
            immCollectiveMortgage,
            immAresDossier,
            cancelAresDossier,
            recoveryProcessType,
            hiringProductBanners
        } = this.props;

        const isAresUser = immProfile.get('isAresUser')
        if (isAresUser) {
            this.props.history.push('/myprofile/loans-mortgages/aresusers');
        }
        const title = formatText('loansMortgagesLanding-title');
        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_6}
                title={formatText('tutorials-loansTitle')}
            />
        );
        const payrollLoanRecordDate = immPayrollLoanRecordStatus.get('registerDate');
        const clientName = immProfile.get('nombreCliente', '');
        const loansWafer = this.buildLoansContent();
        const creditsWafer = this.buildCreditsContent();
        const status = immLoans.get('mortgagesStatus');
        const isMortgagePreapproved = !!status && INVALID_MORTGAGES_STATUS.indexOf(status) === -1;
        const mortgagesWafer = this.buildMortgagesContent(isMortgagePreapproved);
        const cardDeniedVisible = immPayrollLoanRecordStatus.get('cardDeniedVisible');
        const productSubType = immPayrollLoanRecordStatus.get('productSubType');
        const isAccountBlockedValidationFetching = hiringProductBanners.get('isAccountBlockedValidationFetching');
        const isAccountBlockedValidationError = hiringProductBanners.get('isAccountBlockedValidationError');
         const mainButton = {
            label: (
                <FormattedText
                    format="uppercase"
                    value="hireCards-backButtonLabel"
                />
            ),
            url: '/myprofile/loans-mortgages',
            onClick: this.hideBlockedAccountError
        }

        const cancelButton = {
            label: (<FormattedText value="hireCard-errorRestrictionCancleButtonText" />),
            url: '/myprofile/loans-mortgages',
            onClick: this.hideBlockedAccountError
        };

        return (
            <div>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="small" section="loansmortgages" customClass="col-xs-12">
                            <OKHeaderLanding title={title} tutorial={tutorial} inputClassName="ok-header-landing--loansmortgages" />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid grid-view--content-position-positive">
                        <div className="row">
                            <div className="col-xs-12 col-md-9-cc-12">
                                {
                                    this.state.blockedAccountError ?
                                        <LoansError mainButton={mainButton} cancelButton={cancelButton} />
                                        :
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="row">
                                                    {loansWafer}
                                                    {creditsWafer}
                                                    {mortgagesWafer}
                                                </div>
                                                {productSubType === '808' ?
                                                    <PayrollLoanRecordStatus
                                                        immPayrollLoanRecordStatus={mapAresDossierInfoToLoanRecord(immAresDossier)}
                                                        cancelLoanRecord={cancelAresDossier}
                                                        cardDeniedVisible={immAresDossier.get('cardDeniedVisible')}
                                                        immFlagBasedFeatures={immFlagBasedFeatures.get(NOT_ALLOWED_LOANS_CONTRACTING_ARES_COUNTRIES)}
                                                        clientName={clientName}
                                                        setVisibleStep={this.props.setVisibleStep}
                                                        recoveryProcessType={recoveryProcessType}
                                                    />
                                                    :
                                                    <PayrollLoanRecordStatus
                                                        immPayrollLoanRecordStatus={immPayrollLoanRecordStatus}
                                                        cancelLoanRecord={cancelLoanRecord}
                                                        cardDeniedVisible={cardDeniedVisible}
                                                        immFlagBasedFeatures={immFlagBasedFeatures.get(PERSONAL_LOAN_WAFFER)}
                                                        clientName={clientName}
                                                        setVisibleStep={this.props.setVisibleStep}
                                                        recoveryProcessType={recoveryProcessType}


                                                    />

                                                }
                                                {
                                                    isAccountBlockedValidationFetching ?
                                                        <LoadingSection mainButton={mainButton} cancelButton={cancelButton} />
                                                        :
                                                        isAccountBlockedValidationError ?
                                                       null
                                                    :
                                                        <LoansCreditsMortgagesProductBanners
                                                            immCollectives={immCollectives}
                                                            immCredits={immCredits}
                                                            immLoans={immLoans}
                                                            immContractEasyLoan={immContractEasyLoan}
                                                            immFlagBasedFeatures={immFlagBasedFeatures}
                                                            immPayrollLoanRecordStatus={immPayrollLoanRecordStatus}
                                                            clientName={clientName}
                                                            payrollLoanRecordDate={payrollLoanRecordDate}
                                                            immRetailLoan={immRetailLoan}
                                                            immCommercialAds={immCommercialAds}
                                                            immCollectiveMortgage={immCollectiveMortgage}
                                                            isAccountBlockedValidationFetching={isAccountBlockedValidationFetching}
                                                            isAccountBlockedValidationError={isAccountBlockedValidationError}
                                                        />
                                                }

                                                <LoansAndMortagesLegalFooter
                                                    immFlagBasedFeatures={immFlagBasedFeatures}
                                                    immLoans={immLoans}
                                                    immContractEasyLoan={immContractEasyLoan}
                                                />
                                            </div>
                                        </div>
                                }
                            </div>
                            <WebappRender>
                                <div className="col-xs-12 col-md-3">
                                    <div className="row">
                                        <div className="col-xs-6 col-md-12 grid-view--variable-cell-separation">
                                            <CommercialAds path={match.path} type="banner-b" />
                                        </div>
                                        <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                                            <CallMeBack isSmall={true} />
                                        </div>
                                    </div>
                                </div>
                            </WebappRender>
                        </div>
                    </div>
                </div>
                <WebappRender>
                    <div className="container-fluid grid-view__cross-selling">
                        <div className="row">
                            <CommercialAds path={match.path} type="cross-selling" />
                        </div>
                    </div>
                </WebappRender>
            </div>
        );
    }
}

LoansMortgagesView.propTypes = {
    immCollectives: PropTypes.object.isRequired,
    immCredits: PropTypes.object.isRequired,
    immLoans: PropTypes.object.isRequired,
    landingBoxes: PropTypes.object,
    requestPublicInformation: PropTypes.func.isRequired,
    requestMortgagesStatus: PropTypes.func.isRequired,
    fetchPregantedCredits: PropTypes.func.isRequired,
    getCollectiveInfo: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    getMortgageAssociatedInsurances: PropTypes.func.isRequired,
    getSegmentedLoanProducts: PropTypes.func.isRequired,
    immContractEasyLoan: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immPayrollLoanRecordStatus: PropTypes.object.isRequired,
    cancelLoanRecord: PropTypes.func.isRequired,
    immRetailLoan: PropTypes.object.isRequired,
    immCommercialAds: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immMortgageAssociatedInsurances: PropTypes.object.isRequired,
    requestAds: PropTypes.func,
    immCollectiveMortgage: PropTypes.object,
    requestMortgageData: PropTypes.func,
    taxesInformationRequest: PropTypes.func,
    immTaxesInformation: PropTypes.object,
    immMortgageData: PropTypes.object,
    retrieveAresDossier: PropTypes.func.isRequired,
    cancelAresDossier: PropTypes.func.isRequired,
    immAresDossier: PropTypes.object,
    history: PropTypes.object.isRequired,
    validateBlockedAccount: PropTypes.func.isRequired,
    hiringProductBanners: PropTypes.object.isRequired
};

const combineCredits = ({ creditsInvestment, creditsPregranted }) => {
    const byId = creditsInvestment.get('byId').mergeDeep(creditsPregranted.get('byId'));
    const byOrder = creditsInvestment.get('byOrder').concat(creditsPregranted.get('byOrder'));
    const hasPregrantedCredit = creditsPregranted.get('byOrder').count() > 0;

    return Immutable.fromJS({
        byId,
        byOrder,
        hasPregrantedCredit,
        anyAccountWithoutPregrantedCredit: creditsPregranted.get('anyAccountWithoutPregrantedCredit')
    });
};

module.exports = withRouter(connect(
    state => ({
        immCollectives: state.collectives,
        immCredits: combineCredits(state),
        immLoans: state.loans,
        immContractEasyLoan: state.contractEasyLoan,
        landingBoxes: state.landings.get('expandedBoxes').get('pg'),
        immProfile: state.profile,
        immPayrollLoanRecordStatus: state.loanRecordStatus,
        immRetailLoan: state.contractRetailLoan,
        immCommercialAds: state.commercialAds,
        immCollectiveMortgage: state.mortgageRequestCollectiveTag,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immMortgageAssociatedInsurances: state.mortgageAssociatedInsurances,
        immMortgageData: state.mortgageRequestMortgageData,
        immTaxesInformation: state.mortgageRequestTaxesInformation,
        immAresDossier: state.aresDossier,
        hiringProductBanners: state.hiringProductBanners,
    }),
    {
        requestPublicInformation: requestPublicInformation,
        fetchPregantedCredits: fetchPregantedCredits,
        requestMortgagesStatus: requestStatus,
        getMortgageAssociatedInsurances,
        getSegmentedLoanProducts: getSegmentedLoanProducts,
        cancelLoanRecord: cancelLoanRecord,
        setVisibleStep: contractEasyLoanTypeC.simpleActions.contractEasyLoanTypecSetStep,
        requestAds: commercialAdsAction.requestAds,
        getCollectiveInfo: collectiveActions.getCollectiveInfo,
        requestMortgageData: mortgageRequestDataAction.requestMortgageData,
        taxesInformationRequest: mortgageRequestTaxesInformationActions.taxesInformationRequest,
        retrieveAresDossier: retrieveAresDossier,
        cancelAresDossier: cancelDossier,
        recoveryProcessType: PayrollLoanRequestActions.recoveryProcessType,
        validateBlockedAccount: actionsAccount.validateBlockedAccount
    }
)(LoansMortgagesView));
